import { CachedSystem } from './cachedSystem'
import { OLYMPUS_PATHS } from 'constants/apiPaths'
import { COOKIE_AUTH_TOKEN } from 'constants/common'
import { ENV } from 'constants/env'
import Cookies from 'js-cookie'
import { axiosConfigOlympus, callOlympusApi } from 'utils/api'
import { plausibleAPI } from 'utils/plausibleTracking'

export function getLoginLink() {
  return `${ENV.baseOlympusApi}oauth/login?client_id=${ENV.baseOlympusClientId}&redirect_uri=${ENV.baseOlympusApi}oauth/callback `
}

export function getLogoutLink() {
  return `${ENV.baseOlympusApi}oauth/logout?client_id=${ENV.baseOlympusClientId}&redirect_uri=${ENV.baseOlympusApi}oauth/callback `
}

export function getProfile() {
  const authToken = Cookies.get(COOKIE_AUTH_TOKEN)
  if (!authToken) {
    return Promise.reject('No auth token cookie')
  }
  return callOlympusApi(OLYMPUS_PATHS.profile, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
}

export function uploadAvatar(file: File) {
  const formData = new FormData()
  formData.set('avatar', file)

  const options = axiosConfigOlympus({
    method: 'POST',
    data: formData
  })
  return callOlympusApi(OLYMPUS_PATHS.uploadAvatar, options)
}

export function updateProfile(data: any, id: number, roles: number[]) {
  const options = axiosConfigOlympus({
    method: 'PUT',
    data: {
      ...data,
      roles
    }
  })
  return callOlympusApi(OLYMPUS_PATHS.updateProfile + `/${id}`, options)
}

export function login({
  email,
  password
}: {
  email: string
  password: string
}) {
  plausibleAPI.trackEvent('log_in', { props: { ue: email } })
  return callOlympusApi(OLYMPUS_PATHS.login, {
    method: 'POST',
    data: { email, password }
  })
}

export function logout() {
  return callOlympusApi(
    OLYMPUS_PATHS.logout,
    axiosConfigOlympus({
      method: 'POST'
    })
  )
}

export function sendResetPassword({ email }: { email: string }) {
  plausibleAPI.trackEvent('reset_password', { props: { ue: email } })
  return callOlympusApi(OLYMPUS_PATHS.sendResetPasswordLink, {
    method: 'POST',
    data: { email, base_url: window.location.origin }
  })
}

export function changePassword(args: {
  email: string
  token: string
  password: string
  password_confirmation: string
}) {
  return callOlympusApi(OLYMPUS_PATHS.resetPassword, {
    method: 'POST',
    data: args
  })
}

export function getUsers() {
  return CachedSystem.withCached('OlympusUsers', () => {
    return callOlympusApi(OLYMPUS_PATHS.users, axiosConfigOlympus({}))
  })
}
